import ZChip, { ZChipColorValues } from "@/shared/components/Chip";
import { ZTableColumnProps } from "@/shared/components/table";
import { Chip } from "@nextui-org/react";
import dayjs from "dayjs";
import { VendorsAssessmentStatusLabelMap } from ".";
import { VendorDetails } from "../types";

export const AllVendorsListColumns: ZTableColumnProps<VendorDetails>[] = [
  {
    type: "custom",
    fieldName: "vendor_product_name",
    headerName: "Vendor & Product Name",
    sortable: true,
    getSortValue: ({ vendor_product_name }) => vendor_product_name ?? "",
    renderCell: ({ vendor_product_name }) => (
      <div className="text-[#333] flex gap-2 break-all items-center min-h-[40px] pl-3">
        {vendor_product_name}
      </div>
    )
  },
  {
    type: "custom",
    fieldName: "risk_level",
    headerName: "Risk",
    sortable: true,
    renderCell: ({ risk }) => {
      if (!risk) {
        return ""
      }
      const chipColor: Record<string, ZChipColorValues> = {
        "Low": "green", "Medium": "yellow", "High": "red"
      }
      return <ZChip color={chipColor[risk]} > {risk}</ZChip>
    }
  },
  {
    type: "custom",
    fieldName: "status_level",
    headerName: "Status",
    sortable: true,
    renderCell: ({ status }) => {

      const DisplayVendorDetails = VendorsAssessmentStatusLabelMap[status]

      return (
        <div className="flex items-center gap-3">
          <Chip
            variant="bordered"
            radius="full"
            className="h-6 border-1.5"
            classNames={{
              content: "px-1 py-2 flex items-center gap-1",
            }}
            style={{
              color: DisplayVendorDetails?.borderColor ?? "black",
              borderColor: DisplayVendorDetails?.borderColor ?? "black",
              backgroundColor: DisplayVendorDetails?.backgroundColor ?? "transparent",
            }}
          >
            {DisplayVendorDetails?.renderIcon?.()}
          </Chip>
          <div className="text-[#333]">
            {DisplayVendorDetails.label}
          </div>
        </div>
      );
    },
  },
  {
    type: "custom",
    fieldName: "last_assessed",
    headerName: "Last Assessed",
    sortable: true,
    getSortValue: ({ last_assessed }) => dayjs(last_assessed).isValid() ? dayjs(last_assessed).toDate().getTime() : 0,
    renderCell: ({ last_assessed }) => {
      if (dayjs(last_assessed).isValid()) {
        const parsedDate = dayjs.utc(last_assessed.replace("T", " ").split(".")[0]);
        const localDate = parsedDate.local();
        return <div className="text-[#333]">{localDate.fromNow()}</div>;
      }
      return "";
    }
  },

];
